











































import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  PickupCorporateDeadlineBucketItem,
  PICKUP_CORPORATE_DEADLINE_BUCKETS_CONFIG
} from '../PickupCorporateDeadlineBuckets'

@Component({
  name: 'PickupCorporateDeadlineSummaryStrip'
})
class PickupCorporateDeadlineSummaryStrip extends Vue {
  @Prop({ type: Array, required: true, default: () => [] })
  readonly bucketItems!: PickupCorporateDeadlineBucketItem[]

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean

  get displayItems(): PickupCorporateDeadlineBucketItem[] {
    return PICKUP_CORPORATE_DEADLINE_BUCKETS_CONFIG.map((config) => {
      const found = this.bucketItems?.find((item) => item.key === config.key)
      return {
        key: config.key,
        label: config.label,
        count: found ? found.count : 0
      }
    })
  }

  getAlignmentClass(index: number): string {
    if (index === 0) {
      return 'items-start text-left'
    }
    if (index === this.displayItems.length - 1) {
      return 'items-end text-right'
    }
    return 'items-center text-center'
  }
}

export default PickupCorporateDeadlineSummaryStrip;
